import React from "react";

const SmeProfileIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8039 6.72262V2.8277C10.8039 2.13543 10.2427 1.57422 9.55043 1.57422H3.63776C2.94548 1.57422 2.38428 2.13543 2.38428 2.8277V17.425"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 17.4243H7.13269"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.38428 4.79248H5.42069"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.38428 7.95605H7.13325"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2952 13.2422C14.4883 13.2422 15.4555 12.2749 15.4555 11.0818C15.4555 9.88862 14.4883 8.92139 13.2952 8.92139C12.102 8.92139 11.1348 9.88862 11.1348 11.0818C11.1348 12.2749 12.102 13.2422 13.2952 13.2422Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59082 17.4257C9.59737 16.794 9.76288 16.1743 10.0719 15.6245C10.723 14.4658 11.9736 13.73 13.2958 13.7271C14.6179 13.73 15.8684 14.4658 16.5196 15.6245C16.8286 16.1743 16.9941 16.794 17.0006 17.4257"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmeProfileIcon;
